import { addShippingOrderAddressArgsToParams } from 'data/api/transformers/arguments/add-shipping-order-address-args-to-params'
import { AddShippingOrderAddressArgs } from 'types/api/arguments/add-shipping-order-address-args'

import { api } from './api'

export const addShippingOrderAddress = (args: AddShippingOrderAddressArgs) =>
  api.post(`/shipping_orders/${args.shippingOrderId}/shipping_address`, {
    ...addShippingOrderAddressArgsToParams(args),
  })
